/**
 * Profile tabs: Profile | RSVPs | Host
 * Host nested sections: Events | School | Theme | Payment
 *
 * URLs: ?tab=host&section=events|school|theme|payment
 * Also accepts flat aliases (?tab=events|school|payment|theme) and rewrites.
 */

export const PROFILE_TAB = {
  personal: "personal",
  host: "host",
  nights: "nights",
};

export const HOST_SECTION = {
  events: "events",
  school: "school",
  theme: "theme",
  payment: "payment",
};

export const PROFILE_TAB_IDS = {
  personal: "profile-tab-personal",
  host: "profile-tab-host",
  nights: "profile-tab-nights",
};

export const PROFILE_PANEL_IDS = {
  personal: "profile-panel-personal",
  host: "profile-panel-host",
  nights: "profile-panel-nights",
};

export const HOST_SECTION_IDS = {
  events: "profile-host-section-events",
  school: "profile-host-section-school",
  theme: "profile-host-section-theme",
  payment: "profile-host-section-payment",
};

export const HOST_SECTION_PANEL_IDS = {
  events: "profile-host-panel-events",
  school: "profile-host-panel-school",
  theme: "profile-host-panel-theme",
  payment: "profile-host-panel-payment",
};

export const HOST_SECTION_ORDER = [
  HOST_SECTION.events,
  HOST_SECTION.school,
  HOST_SECTION.theme,
  HOST_SECTION.payment,
];

export function isHostSection(value) {
  return HOST_SECTION_ORDER.includes(value);
}

/**
 * Normalize search params into { tab, section }.
 * Flat aliases (events/school/payment/theme) become host + section.
 */
export function normalizeProfileSearch(tabParam, sectionParam, { defaultTab = "personal" } = {}) {
  if (tabParam === "theme" || sectionParam === "theme") {
    return { tab: PROFILE_TAB.host, section: HOST_SECTION.theme, rewrite: tabParam !== "host" || sectionParam !== "theme" };
  }
  if (tabParam === "events" || sectionParam === "events") {
    return { tab: PROFILE_TAB.host, section: HOST_SECTION.events, rewrite: tabParam !== "host" || sectionParam !== "events" };
  }
  if (tabParam === "school" || sectionParam === "school") {
    return { tab: PROFILE_TAB.host, section: HOST_SECTION.school, rewrite: tabParam !== "host" || sectionParam !== "school" };
  }
  if (tabParam === "payment" || sectionParam === "payment") {
    return { tab: PROFILE_TAB.host, section: HOST_SECTION.payment, rewrite: tabParam !== "host" || sectionParam !== "payment" };
  }
  if (tabParam === PROFILE_TAB.host || defaultTab === "host") {
    const section = isHostSection(sectionParam) ? sectionParam : HOST_SECTION.events;
    return {
      tab: PROFILE_TAB.host,
      section,
      rewrite: Boolean(sectionParam) && sectionParam !== section ? true : false,
    };
  }
  if (tabParam === PROFILE_TAB.nights || defaultTab === "nights") {
    return { tab: PROFILE_TAB.nights, section: null, rewrite: false };
  }
  return { tab: PROFILE_TAB.personal, section: null, rewrite: false };
}

export function resolveInitialProfileTab(defaultTab, tabParam, onboarding) {
  if (onboarding) return PROFILE_TAB.personal;
  return normalizeProfileSearch(tabParam, null, { defaultTab }).tab;
}

export function resolveInitialHostSection(sectionParam, tabParam) {
  return normalizeProfileSearch(tabParam, sectionParam).section || HOST_SECTION.events;
}

export function profileTabOrder({ account } = {}) {
  const order = [PROFILE_TAB.personal, PROFILE_TAB.nights];
  if (account) order.push(PROFILE_TAB.host);
  return order;
}

export function isHostSettingsSection(section) {
  return section === HOST_SECTION.payment || section === HOST_SECTION.school;
}

export function isThemeSection(section) {
  return section === HOST_SECTION.theme;
}
